<template>
	<div class>
		<ModalBox v-model="legacyModalVisible" :size="modalSize" hide-close header-class="!hidden" wrapper-classes="lg:h-auto lg:max-h-none p-6">

			<div class="flex flex-wrap">
				<div class="w-full">
					<h5>Edit Origin URL</h5>
					<div class="mt-3">
						<FormInput 
							label="Your new origin Domain"
							size="md" 
							v-model="originUrl" 
							class="mb-2" placeholder="Enter new domain or IP address" />
					</div>
					<div class="text-right w-full">
						<FormButton type="secondary" class="mr-2" size="md" @click="dismiss">
							Cancel
						</FormButton>
						<FormButton 
							type="main" 
							@click="edit(originUrl)" 
							size="md"
							:disabled="this.originUrl === '' || processing ">
							{{ !processing ? 'Save Change' : 'Saving' }}
						</FormButton>
					</div>
				</div>
			</div>
		
</ModalBox>
	</div>
</template>

<script>
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import _ from 'lodash';
import ClipLoader from "@/components/ui/ClipLoader.vue";
import FormButton from '@/components/Atoms/FormButton.vue';
import FormInput from '@/components/Atoms/FormInput.vue';

export default {
	name: 'EditOriginModal',
	mixins: [legacyModalBridgeMixin],
	legacyModalId: 'modal-edit-origin',
	components: {
		ModalBox,
        FormButton,
        ClipLoader,
		FormInput,
	},
	props: {
      	editOrigin: { 
			type: Function 
		},
		modalSize: {
			type: String,
			default: 'sm',
			validator(v) {
				return ['xl', 'lg', 'md', 'sm'].some(size => size === v);
			}
		},
	},
	data() {
		return {
			processing: false,
            originUrl: ''
		};
	},
	computed: {
	},
    async mounted() {},
	methods: {
		dismiss() {
			this.hideLegacyModal();
			this.originUrl = ''
			setTimeout(() => { this.processing = false; }, 1000);
		},
        async edit(url){
			if (url === '') {
				return
			}
			this.processing = true
            await this.editOrigin(url);
			this.processing = false
            this.dismiss();
        }
	},
};
</script>

<style>
</style>